module.exports = __webpack_public_path__ + "img/horizontal_3_2_0.f0f2da1c.png";